// Badge del método de cobro (efectivo / tarjeta / SPEI) — presentación compartida del portal.
import { Badge } from '@/kit';
import {
    NO_CHARGE_LABEL,
    isNoCharge,
    paymentMethodName,
    paymentMethodsLabel,
    toPaymentLineMethod,
    type PaymentLine,
} from '@/shared/lib/format/salePaymentLines';
import { PENDING_CELL } from '../customers/lib/customersFormat';

const VARIANT: Record<string, string> = { CASH: 'success', CARD: 'info', SPEI: 'secondary' };

/** Varios pagos: «Tarjeta + Efectivo»; cobro de $0: «Sin cobro»; sin método en otro caso, guion. */
export function PaymentBadge({
    method,
    payments,
    amountCents,
}: {
    method: string | null;
    payments?: readonly PaymentLine[] | null;
    /** Con él, un método nulo de un cobro de $0 se nombra «Sin cobro». */
    amountCents?: number;
}) {
    if (payments && payments.length > 1) {
        return <Badge variant="secondary">{paymentMethodsLabel(payments)}</Badge>;
    }
    if (!method) {
        const noCharge = amountCents !== undefined && isNoCharge(method, amountCents);
        return (
            <span className="text-muted-foreground">
                {noCharge ? NO_CHARGE_LABEL : PENDING_CELL}
            </span>
        );
    }
    const variant = VARIANT[toPaymentLineMethod(method)] ?? 'default';
    return <Badge variant={variant}>{paymentMethodName(method)}</Badge>;
}
